import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const projects = [
  {
    id: 1,
    title: 'E-Commerce Platform',
    summary: 'A full-featured online store built with React, Node.js, and MongoDB. Features include real-time inventory, payment processing, and responsive design.',
    tech: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    link: '#',
    image: 'https://images.unsplash.com/photo-1661956602116-aa6865609028?w=1200&q=80',
  },
  {
    id: 2,
    title: '3D Portfolio Website',
    summary: 'An immersive portfolio experience using Spline 3D and GSAP animations. Showcases creative work with interactive 3D elements.',
    tech: ['React', 'Spline', 'GSAP', 'CSS3'],
    link: '#',
    image: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=1200&q=80',
  },
  {
    id: 3,
    title: 'Task Management App',
    summary: 'A collaborative project management tool with drag-and-drop functionality, real-time updates, and team collaboration features.',
    tech: ['React', 'Firebase', 'Material UI', 'Redux'],
    link: '#',
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=1200&q=80',
  },
  {
    id: 4,
    title: 'Weather Dashboard',
    summary: 'A beautiful weather application with animated backgrounds, 7-day forecasts, and location-based weather data visualization.',
    tech: ['React', 'OpenWeather API', 'Chart.js', 'CSS3'],
    link: '#',
    image: 'https://images.unsplash.com/photo-1592210454359-9043f067919b?w=1200&q=80',
  },
];

const Works = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const cards = cardsRef.current.filter(Boolean);

    cards.forEach((card, index) => {
      // Each card except the last one gets pinned and scaled down as the next card overlaps
      if (index < cards.length - 1) {
        ScrollTrigger.create({
          trigger: card,
          start: 'top top',
          end: 'bottom top',
          pin: true,
          pinSpacing: false,
          scrub: true,
        });

        // Scale down and dim the card as the next one overlaps it
        gsap.to(card, {
          scale: 0.9,
          opacity: 0.5,
          scrollTrigger: {
            trigger: cards[index + 1],
            start: 'top bottom',
            end: 'top top',
            scrub: true,
          },
        });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <section className='works-parallax' id='works' ref={sectionRef}>
      <div className='works-parallax-header'>
        <h2 className='works-parallax-title'>My Work</h2>
        <p className='works-parallax-subtitle'>A selection of projects I've crafted with passion</p>
      </div>

      {projects.map((project, index) => (
        <div
          className='works-parallax-card'
          key={project.id}
          ref={(el) => (cardsRef.current[index] = el)}
        >
          <div className='works-parallax-card-bg'>
            <img src={project.image} alt={project.title} />
            <div className='works-parallax-card-overlay'></div>
          </div>

          <div className='works-parallax-card-content'>
            <h3 className='works-parallax-card-title'>{project.title}</h3>
            <p className='works-parallax-card-summary'>{project.summary}</p>
            <div className='works-parallax-tech-stack'>
              {project.tech.map((tech, i) => (
                <span key={i} className='works-parallax-tech-tag'>{tech}</span>
              ))}
            </div>
            <a
              href={project.link}
              target='_blank'
              rel='noreferrer'
              className='works-parallax-see-live'
            >
              See Live <i className="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Works;
